import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import PropTypes from 'prop-types'

import Layout from '../components/Layout'
import Seo from '../components/seo'
import Hero from '../components/Hero'
import Post from '../components/Post'

const PostPage = ({ pageContext }) => {
  const data = useStaticQuery(graphql`
  query HeroPost {
    contentfulHero(slug: {eq: "hero-post"}) {
      coverImage {
        file {
          url
          fileName
        }
      }
    }
  }
`)
  const { contentfulHero } = data
  const { coverImage } = contentfulHero
  const { post } = pageContext

  const { title, image, slug } = post
  const url = `https://node.dev/post/${slug}`
  return (
    <Layout>
      <Seo type='article' title={title} image={`http:${image.file.url}`} url={url} />
      <Hero title={title} image={coverImage} />
      <section className='pull-top-100px'>
        <Post {...post} />
      </section>
    </Layout>
  )
}

PostPage.propTypes = {
  pageContext: PropTypes.shape()
}

PostPage.defaultProps = {
  pageContext: {}
}

export default PostPage
